export default {
  // 根据多个提单号查询行项目
  GET_DETAIL_LIST: '/warehouse/storageLade/listStorageLadePickingBySaleInvoice',
  // 事务处理类型AjaxSelect不分页
  LIST_TRANSACTION_TYPE: '/financial/financeSalesTransactionType/listTableInfos',
  // 事务处理类型列表分页
  LIST_TRANSACTION_TYPE_BYPAGE: '/financial/financeSalesTransactionType/listTableInfosByPage',
  // 新增事务处理类型
  ADD_TRANSACTION_TYPE: '/financial/financeSalesTransactionType/add',
  // 修改事务处理类型
  UPDATE_TRANSACTION_TYPE: '/financial/financeSalesTransactionType/update',
  // 禁用、启用，支持批量
  UPDATE_TRANSACTION_TYPE_STATUS: '/financial/financeSalesTransactionType/updateStatus',
  // 查询事务处理类型详情
  GET_TRANSACTION_DETAIL: '/financial/financeSalesTransactionType/getDetail',
  // 新增销售发票
  ADD_INVOICE: '/financial/financeSalesInvoice/add',
  // 修改销售发票
  UPDATE_INVOICE: '/financial/financeSalesInvoice/update',
  // 计算行信息
  CAL_LIST: '/financial/financeSalesInvoice/calculate',
  // 获取详情
  GET_DETAIL: '/financial/financeSalesInvoice/getDetail',
  // 查询销售列表
  GET_LIST: '/financial/financeSalesInvoice/listSalesInvoices',
  // 批量删除接口
  DELETE_DATA: '/financial/financeSalesInvoice/deleteSalesInvoices',
  // 批量提交
  BATCH_SUBMIT: '/financial/financeSalesInvoice/batchSubmit',
  // 批量撤回
  BATCH_WITHDRAW: '/financial/financeSalesInvoice/batchWithdraw',
  // 批量退回
  BATCH_RETURN: '/financial/financeSalesInvoice/batchReturn',
  // 冲销
  REVERSE: '/financial/financeSalesInvoice/reverse',
  // 导出销售发票
  EXPORT_INVOICE: '/financial/financeSalesInvoice/exportExcel',
  // 导出事务处理类型
  EXPORT_TYPE: '/financial/financeSalesTransactionType/exportExcel',
  // 根据销售提单获取发票信息--单独开票
  GET_INVOICE_BY_LADINGNO_ALONE: '/financial/financeSalesInvoice/getFinanceSalesInvoiceAlone',
  // 根据销售提单获取发票信息--合并开票
  GET_INVOICE_BY_LADINGNO: '/financial/financeSalesInvoice/getFinanceSalesInvoiceData',
  // 根据服务合同获取发票信息
  GET_INVOICE_BY_CONTRACT: '/financial/financeSalesInvoice/convertFromSalesContract',
  // 根据退货单号查询行项目--单独开票
  GET_INVOICE_BY_RETURNNO_ALONE: '/financial/financeSalesInvoice/getSalesReturnToSalesInvoiceAlone',
  // 根据多个退货单号查询行项目--合并开票
  GET_INVOICE_BY_RETURNNO: '/financial/financeSalesInvoice/getSalesReturnToSalesInvoiceData',
  //批量过账
  BATCH_VOUCHER: '/financial/financeSalesInvoice/batchSyncVoucher',
  //批量标记过账
  BATCH_SIGN_VOUCHER: '/financial/financeSalesInvoice/batchSignSyncVoucher',
  /**打印查询 */
  GET_FILE: '/maindata/dict/getFileTemplate',
  /**打印或下载 */
  EXPORT_PRINT: '/sales/financeSales/exportPrint',
  /**应收结算行信息查询 */
  RECIVE_SETTLEMENT_LINE_PAGE: '/financial/receivableSettlementLine/page',
  /**应收结算头信息查询 */
  RECIVE_SETTLEMENT_PAGE: '/financial/receivableSettlement/page',
  // 选择蓝票
  BLUE_TICKET_API: '/financial/financeSalesInvoiceInfo/c_page',
  // 根据结算单号获取附件信息
  QUERY_FILELIST: '/financial/receivableSettlement/queryAttachment',
};
